export default {
  startNendo: 1970,         // 閲覧開始年度
  plotNendo: 1970,          // 確認プロット整備済み年度
  dbNendo: 2005,            // DB整備済み年度
  imageNendo: 1970,         // 三面画像処理済み年度
  shobunNendo: 1999,        // 処分の概要書開始年度
  kosakuNendo: 2015,        // 工作物の閲覧開始年度
  keitsuDate: '2007-07-01', // 計画通知の閲覧対象年月日
  kosakuDate: '2001/04/01', // 工作物の閲覧対象年月日
  datepickerMinValue: '1868-01-25', // 入力制御:明治以前の日付は入力させない

  // 閲覧対象
  browseTargets: [
    {
      code: 0,
      view: 'menu',
      caption: '建築計画概要書等閲覧システム',
      data: 'ユーザー'
    },
    {
      code: 1,
      view: 'browsegaiyo',
      caption: '建築計画概要書閲覧システム',
      data: '建築確認データ'
    },
    {
      code: 2,
      view: 'browseelv',
      caption: '昇降機台帳閲覧システム',
      data: '昇降機データ'
    },
    {
      code: 3,
      view: 'menu',
      caption: '定期報告概要書閲覧システム',
      data: '定期報告データ'
    },
    {
      code: 4,
      view: 'browsesproad',
      caption: '位置指定道路図閲覧システム',
      data: '位置指定道路データ'
    },
    {
      code: 5,
      view: 'browsekaihatsu',
      //caption: '開発登録簿閲覧システム',
      //caption: '開発宅造閲覧システム',
      caption: '開発・造成・土石の堆積閲覧システム',
      data: '開発登録簿データ'
    },
    {
      code: 6,
      view: 'browsetakuzo',
      caption: '造成計画平面図閲覧システム',
      data: '造成計画平面図データ'
    },
    {
      code: 7,
      view: 'browsekyoai',
      caption: '狭あい道路実測図閲覧システム',
      data: '狭あい道路実測図データ'
    },
    {
      code: 8,
      view: 'browsekosaku',
      caption: '工作物システム',
      data: '工作物データ'
    },
  ],
  
  // API
  apiDef: [
    {
      name: 'visited',
      url: 'api/visitor',
      description: 'クライアント情報取得'
    },
    {
      name: 'authorize',
      url: 'api/users/authenticate',
      description: 'ユーザ認証'
    },
    {
      name: 'userinfo',
      url: 'api/users',
      description: 'ユーザ情報取得'
    },
    {
      name: 'resetpasswd',
      url: 'api/users/resetpasswd',
      description: 'パスワード再設定'
    },
    {
      // 現在使用されていない？ 検索結果0
      name: 'RegistRef',
      url: 'api/users/RegistRef',
      description: '概要書閲覧履歴登録'
    },
    {
      // 現在使用されていない？ 検索結果0
      name: 'RegistPrint',
      url: 'api/users/RegistPrint',
      description: '概要書印刷履歴登録'
    },
    {
      name: 'RegistLog',
      url: 'api/Log/Regist',
      description: 'ログ保存'
    },
    {
      name: 'ULog',
      url: 'api/ULog',
      description: 'ULog'
    },
    {
      name: 'AllTowns',
      url: 'api/AllTowns',
      description: '町一覧取得（廃町含む）'
    },
    {
      name: 'Towns',
      url: 'api/Towns',
      description: '町一覧取得（廃町含まず）'
    },
    {
      name: 'Chiban',
      url: 'api/Chiban',
      description: '地番データ取得'
    },
    {
      name: 'Gaiyo',
      url: 'api/Gaiyo',
      description: '建築計画概要書データ取得'
    },
    {
      name: 'BrowseCount',
      url: 'api/Gaiyo/BrowseCount',
      description: '建築計画概要書閲覧回数'
    },
    {
      name: 'GaiyoSummary',
      url: 'api/GaiyoSummary',
      description: '建築計画概要書一覧データ取得'
    },
    {
      name: 'GaiyoSearch',
      url: 'api/GaiyoSearch',
      description: '建築計画概要書番号検索'
    },
    {
      name: 'AddrSearch',
      url: 'api/GaiyoSearch/searchaddr',
      description: '建築計画概要書住所検索'
    },
    {
      name: 'AttrSearch',
      url: 'api/GaiyoSearch/searchattr',
      description: '建築計画概要書詳細検索'
    },
    {
      name: 'AttrSearchCount',
      url: 'api/GaiyoSearch/searchattrcount',
      description: '建築計画概要書詳細検索結果件数取得'
    },
    {
      name: 'ExamSearch',
      url: 'api/GaiyoSearch/searchexam',
      description: '審査処分経過検索'
    },
    {
      name: 'ExamSearchEx',
      url: 'api/GaiyoSearch/searchexamex',
      description: '審査処分経過検索（工作物対応）'
    },
    {
      name: 'KousakuSummary',
      url: 'api/KousakuSummary',
      description: '工作物一覧データ取得'
    },
    {
      name: 'Kosaku',
      url: 'api/Kosaku',
      description: '工作物概要書データ取得'
    },
    {
      name: 'Estate',
      url: 'api/Estate',
      description: '同一物件概要書一覧データ取得'
    },
    {
      name: 'XY',
      url: 'api/Gaiyo/getxy',
      description: '確認プロット座標取得'
    },
    {
      name: 'KisaiShomei',
      url: 'api/KisaiShomei',
      description: '記載証明書データ取得'
    },
    {
      name: 'KisaiShomeiEx',
      url: 'api/KisaiShomei/kisaiex',
      description: '記載証明書拡張データ取得'
    },
    {
      name: 'KisaiNo',
      url: 'api/KisaiShomei/IssueDate',
      description: '記載証明書発行番号取得'
    },
    {
      name: 'KisaiComment',
      url: 'api/KisaiShomei/writecomment',
      description: '記載証明書コメント書き込み'
    },
    {
      name: 'Elv',
      url: 'api/Elv',
      description: '昇降機データ取得'
    },
    {
      name: 'elvSummary',
      url: 'api/elvSummary',
      description: '昇降機一覧データ取得'
    },
    {
      name: 'Teiho',
      url: 'api/Teiho',
      description: '定期報告データ取得'
    },
    {
      name: 'TeihoSummary',
      url: 'api/TeihoSummary',
      description: '定期報告一覧データ取得'
    },
    {
      name: 'SpecRoad',
      url: 'api/SpecRoad',
      description: '位置指定データ取得'
    },
    {
      name: 'ShiteiSearch',
      url: 'api/ShiteiSearch',
      description: '位置指定道路道路番号検索'
    },
    {
      name: 'Kaihatsu',
      url: 'api/Kaihatsu',
      description: '開発登録簿データ取得'
    },
    {
      name: 'KaihatsuSearch',
      url: 'api/KaihatsuSearch',
      description: '開発登録簿番号検索'
    },
    {
      name: 'Takuzo',
      url: 'api/Takuzo',
      description: '宅造データ取得'
    },
    {
      name: 'TakuzoSearch',
      url: 'api/Takuzo/search',
      description: '宅造番号検索'
    },
    {
      name: 'Kyoai',
      url: 'api/Kyoai',
      description: '狭あい道路データ取得'
    },
    {
      name: 'KyoaiSummary',
      url: 'api/KyoaiSummary',
      description: '狭あい道路一覧データ取得'
    },
    {
      name: 'KyoaiSearch',
      url: 'api/KyoaiSearch',
      description: '狭あい道路番号検索'
    },
    {
      name: 'KenkakuPlotIndex',
      url: 'api/KenkakuPlotIndex',
      description: '建築確認プロット地図索引図検索'
    },
    {
      name: 'KenkakuPlotIndexNendo',
      url: 'api/KenkakuPlotIndex/SearchNendo',
      description: '建築確認プロット地図索引図年度検索'
    },
    {
      name: 'KenkakuPlot',
      url: 'api/KenkakuPlot',
      description: '建築確認プロット地図検索'
    },
    {
      name: 'KaihatsuPlotIndex',
      url: 'api/KaihatsuPlotIndex',
      description: '開発・造成・土石の堆積プロット地図索引図検索'
    },
    {
      name: 'KaihatsuPlotIndexNendo',
      url: 'api/KaihatsuPlotIndex/SearchNendo',
      description: '開発・造成・土石の堆積プロット地図索引図年度検索'
    },
    {
      name: 'KaihatsuPlot',
      url: 'api/KaihatsuPlot',
      description: '開発・造成・土石の堆積プロット地図検索'
    },
    {
      name: 'SendPasswdMail',
      url: 'api/Users/SendPasswdMail',
      description: 'パスワード再設定メール送信'
    },
    {
      name: 'Dancho',
      url: 'api/DaichoSummary',
      description: '台帳検索'
    },
    {
      name: 'DanchoImage',
      url: 'api/DaichoFileLink',
      description: '台帳画像検索'
    },
  ],
  // タイル
  tileDef: [
    {
      name: 'bgmap',
      url: 'ykhdm/{z}/{x}/{y}.png',
      description: '背景地形図タイルデータ',
    },
    {
      name: 'bldplot',
      type: 'point',
      url: 'bldplot/{z}/{x}/{y}.pbf',
      description: '建築確認プロットタイルデータ',
      key: '受付番号',
      label: '受付番号',
      title: '受付番号',
    },
    {
      name: 'elvplot',
      type: 'point',
      url: 'elvplot/{z}/{x}/{y}.pbf',
      description: '昇降機プロットタイルデータ',
      //key: 'DAICHO_ID',
      key: 'UKE_NO',
      label: 'UKE_NO',
      title: '受付番号',
    },
    {
      name: 'teihoplot',
      type: 'point',
      url: 'teihoplot/{z}/{x}/{y}.pbf',
      description: '定期報告プロットタイルデータ',
      key: 'SEIRI_NO',
      label: 'SEIRI_NO',
      title: '整理番号',
    },
    {
      name: 'shitei',
      type: 'line',
      url: 'shitei/{z}/{x}/{y}.pbf',
      description: '位置指定道路タイルデータ',
      key: 'SEQ',
      //key: '位置指定',
      label: '位置指定',
      title: '位置指定番号',
    },
    {
      name: 'kaihatsu',
      type: 'polygon',
      url: 'kaihatsu/{z}/{x}/{y}.pbf',
      description: '開発許可区域タイルデータ',
      key: 'SEQ',
      //key: '開発許可NO',
      label: '開発許可NO',
      title: '開発許可番号',
    },
    {
      name: 'takuzo',
      type: 'polygon',
      url: 'takuzo/{z}/{x}/{y}.pbf',
      description: '宅造タイルデータ',
      key: 'SEQ',
      //key: '宅造許可NO',
      label: '宅造許可NO',
      title: '宅造許可番号',
    },
    {
      name: 'kyoai',
      type: 'point',
      url: 'kyoai/{z}/{x}/{y}.pbf',
      description: '狭あい道路タイルデータ',
      key: '受付番号',
      label: '受付番号',
      title: '受付番号',
    },
    {
      name: 'kenkakusheet',
      type: 'polygon',
      url: 'kenkakusheet/{z}/{x}/{y}.pbf',
      description: '建築確認プロット地図図郭',
    },
    {
      name: 'kaihatsusheet',
      type: 'polygon',
      url: 'kaihatsusheet/{z}/{x}/{y}.pbf',
      description: '開発・造成・土石の堆積プロット地図図郭',
    },
    {
      name: 'seibisokushin',
      type: 'polygon',
      url: 'seibisokushin/{z}/{x}/{y}.pbf',
      description: '整備促進路線タイルデータ',
    },
    {
      name: 'douroshubetsu',
      type: 'line',
      url: 'douroshubetsu/{z}/{x}/{y}.pbf',
      description: '道路種別図タイルデータ',
    },
  ],

  // obsoleted
  menuItems: [
    {
      name: 'トップメニュー',
      url: '/'
    },
  ],

  // 区コード表
  Wards: [
    { code: 14117, name: '青葉区', nendo: 1994 },
    { code: 14112, name: '旭区', nendo: 0 },
    { code: 14116, name: '泉区', nendo: 1986 },
    { code: 14107, name: '磯子区', nendo: 0 },
    { code: 14102, name: '神奈川区', nendo: 0 },
    { code: 14108, name: '金沢区', nendo: 0 },
    { code: 14111, name: '港南区', nendo: 0 },
    { code: 14109, name: '港北区', nendo: 0 },
    { code: 14115, name: '栄区', nendo: 1986 },
    { code: 14114, name: '瀬谷区', nendo: 0 },
    { code: 14118, name: '都筑区', nendo: 1994},
    { code: 14101, name: '鶴見区', nendo: 0 },
    { code: 14110, name: '戸塚区', nendo: 0 },
    { code: 14104, name: '中区', nendo: 0 },
    { code: 14103, name: '西区', nendo: 0 },
    { code: 14106, name: '保土ケ谷区', nendo: 0 },
    { code: 14113, name: '緑区', nendo: 0 },
    { code: 14105, name: '南区', nendo: 0 },
    { code: 14100, name: 'NT', nendo: 0 },
  ],

  WardsBalics: [
    { code: 1, name: '鶴見区', shortname: "鶴" },
    { code: 2, name: '神奈川区', shortname: "神" },
    { code: 3, name: '西区', shortname: "西" },
    { code: 4, name: '中区', shortname: "中" },
    { code: 5, name: '南区', shortname: "南" },
    { code: 6, name: '保土ケ谷区', shortname: "保" },
    { code: 7, name: '磯子区', shortname: "磯" },
    { code: 8, name: '金沢区', shortname: "金" },
    { code: 9, name: '港北区', shortname: "港北" },
    { code: 10, name: '戸塚区', shortname: "戸" },
    { code: 11, name: '港南区', shortname: "港南"},
    { code: 12, name: '旭区', shortname: "旭" },
    { code: 13, name: '緑区', shortname: "緑" },
    { code: 14, name: '瀬谷区', shortname: "瀬" },
    { code: 15, name: '栄区', shortname: "栄" },
    { code: 16, name: '泉区', shortname: "泉" },
    { code: 17, name: '青葉区', shortname: "青" },
    { code: 18, name: '都筑区', shortname: "都" },
    { code: 30, name: '計画通知', shortname: "計" },
  ],

  // 資格登録者コード表
  Register: [
    { code: 0, name: '大臣' },
    { code: 1, name: '北海道知事' },
    { code: 2, name: '青森県知事' },
    { code: 3, name: '岩手県知事' },
    { code: 4, name: '宮城県知事' },
    { code: 5, name: '秋田県知事' },
    { code: 6, name: '山形県知事' },
    { code: 7, name: '福島県知事' },
    { code: 8, name: '茨城県知事' },
    { code: 9, name: '栃木県知事' },
    { code: 10, name: '群馬県知事' },
    { code: 11, name: '埼玉県知事' },
    { code: 12, name: '千葉県知事' },
    { code: 13, name: '東京都知事' },
    { code: 14, name: '神奈川県知事' },
    { code: 15, name: '新潟県知事' },
    { code: 16, name: '富山県知事' },
    { code: 17, name: '石川県知事' },
    { code: 18, name: '福井県知事' },
    { code: 19, name: '山梨県知事' },
    { code: 20, name: '長野県知事' },
    { code: 21, name: '岐阜県知事' },
    { code: 22, name: '静岡県知事' },
    { code: 23, name: '愛知県知事' },
    { code: 24, name: '三重県知事' },
    { code: 25, name: '滋賀県知事' },
    { code: 26, name: '京都府知事' },
    { code: 27, name: '大阪府知事' },
    { code: 28, name: '兵庫県知事' },
    { code: 29, name: '奈良県知事' },
    { code: 30, name: '和歌山県知事' },
    { code: 31, name: '鳥取県知事' },
    { code: 32, name: '島根県知事' },
    { code: 33, name: '岡山県知事' },
    { code: 34, name: '広島県知事' },
    { code: 35, name: '山口県知事' },
    { code: 36, name: '徳島県知事' },
    { code: 37, name: '香川県知事' },
    { code: 38, name: '愛媛県知事' },
    { code: 39, name: '高知県知事' },
    { code: 40, name: '福岡県知事' },
    { code: 41, name: '佐賀県知事' },
    { code: 42, name: '長崎県知事' },
    { code: 43, name: '熊本県知事' },
    { code: 44, name: '大分県知事' },
    { code: 45, name: '宮崎県知事' },
    { code: 46, name: '鹿児島県知事' },
    { code: 47, name: '沖縄県知事' },
  ],

  // 構造区分コード表
  kozoKubun: [
    { code: 0, name: '' },
    { code: 1, name: '木造' },
    { code: 2, name: '組積造' },
    { code: 3, name: '補強ＣＢ造' },
    { code: 4, name: 'Ｓ造' },
    { code: 5, name: 'ＲＣ造' },
    { code: 6, name: 'ＳＲＣ造' },
    { code: 7, name: '無筋Ｃ造' },
    { code: 8, name: 'その他' },
  ],

  // 資格区分コード表
  shikakuKubun: [
    { code: 0, name: '' },
    { code: 1, name: '一級' },
    { code: 2, name: '二級' },
    { code: 3, name: '木造' },
    { code: 4, name: '指定なし' },
  ],

  // 特例区分コード表
  tokureiKubun: [
    { code: 0, name: '' },
    { code: 1, name: '道路高さ制限不適用' },
    { code: 2, name: '隣地高さ制限不適用' },
    { code: 3, name: '北側高さ制限不適用' },
  ],

  // 和暦定義
  warekiDef: [
    { id: 0, era: '', shortEra: '', firstYear: 0, startNendo: 0, lastNendo: 0, startMonth: 0, startDate: 0},
    { id: 1, era: '明治', shortEra: 'M', firstYear: 1868, startNendo: 0, lastNendo: 0 ,startMonth: 1, startDate: 25},
    { id: 2, era: '大正', shortEra: 'T', firstYear: 1912, startNendo: 0, lastNendo: 0, startMonth: 7,startDate: 30 },
    { id: 3, era: '昭和', shortEra: 'S', firstYear: 1926, startNendo: 25, lastNendo: 63, startMonth: 12, startDate: 25 },
    { id: 4, era: '平成', shortEra: 'H', firstYear: 1989, startNendo: 1, lastNendo: 31, startMonth: 1, startDate: 8 },
    { id: 5, era: '令和', shortEra: 'R', firstYear: 2019, startNendo: 2, lastNendo: 8, startMonth: 5, startDate: 1 }
  ],

  gutaiSyuyoYotoDef: [
    { code: 1, name: '建築物' },
    { code: 2, name: '擁壁' },
    { code: 3, name: '昇降機等' },
    { code: 4, name: '看板等' },
    { code: 5, name: 'その他工作物' },
  ],

  kojiSybtDef: [
    { code: 0, name: '新築' },
    { code: 1, name: '増築' },
    { code: 2, name: '改築' },
    { code: 3, name: '移転' },
    { code: 4, name: '用途変更' },
  ],

  kubunDef:[
    { code: 1, name: '一般' },
    { code: 2, name: '計画通知' },
  ],

  stopSybtDef:[
    { code: 0, name: '' },
    { code: 1, name: '取下' },
    { code: 2, name: '取止' },
    { code: 3, name: '未確' },
    { code: 4, name: '不適合' },
  ],

  messageText: {
    DisableNendo1: '指定された概要書は閲覧対象年度外です。',
    DisableNendo2: '指定された概要書はデータ未整備につき閲覧できません。',
    JdgJokyo0: '審査未了閲覧できません。',
    JdgJokyo2: '不適合につき閲覧できません。',
    JdgJokyo3: '取下げにつき閲覧できません。',
    JdgJokyo4: '審査中断中につき閲覧できません。',
    JdgJokyo5: '取止めにつき閲覧できません。',
  },

  // プロット地図の年度表示色
  plotColor: [
    { code: 0, r: 0, g: 0, b: 0 },
    { code: 1, r: 255, g: 0, b: 0 },
    { code: 2, r: 0, g: 255, b: 0 },
    { code: 3, r: 255, g: 255, b: 0 },
    { code: 4, r: 0, g: 0, b: 255 },
    { code: 5, r: 255, g: 0, b: 255 },
    { code: 6, r: 0, g: 255, b: 255 },
    { code: 7, r: 96, g: 96, b: 96 },
    { code: 8, r: 255, g: 128, b: 128 },
    { code: 9, r: 128, g: 0, b: 255 },
    { code: 10, r: 230, g: 121, b: 40 },
    { code: 11, r: 255, g: 128, b: 255 },
  ],

  Syuyo: [
    { code: 1, name: '専用住宅' },
    { code: 2, name: '共同住宅' },
    { code: 3, name: '住宅' },
    { code: 4, name: '事務所' },
    { code: 5, name: '店舗' },
    { code: 6, name: '事務所併用住宅' },
    { code: 7, name: '店舗併用住宅' },
    { code: 8, name: '工場' },
    { code: 9, name: '倉庫' },
    { code: 10, name: '物置' },
    { code: 11, name: 'その他' },
  ],

  KozoSybtDef: [
    { code: 1, name: '木造' },
    { code: 2, name: '鉄骨造' },
    { code: 3, name: 'RC造' },
    { code: 4, name: 'SRC造' },
    { code: 5, name: '防火構造' },
    { code: 6, name: '簡易耐火(イ)溝造' },
    { code: 7, name: '簡易耐火(ロ)溝造' },
    { code: 8, name: '耐火溝造' },
  ],
}
